import React from 'react';

import { useApplicationRuntimeContext } from '@context/ApplicationRuntimeContext';
import { ReactFCV } from '@types';

import { ISizeProps } from '../model';
import { StyledProductCol } from '../styled';

export interface ITextProps extends ISizeProps {
  isEngraving?: boolean;
  textContent?: string | React.ReactNode;
}

export const Text: ReactFCV<ITextProps> = ({ isEngraving, textContent, ...rest }) => {
  const {
    applicationSettings: { secondaryCurrency },
  } = useApplicationRuntimeContext();

  const isDualPriceLayout = Boolean(secondaryCurrency);
  return (
    <StyledProductCol
      xs={9}
      sm={isDualPriceLayout ? 3 : 4}
      md={isDualPriceLayout ? 4 : 5}
      isEngraving={isEngraving}
      {...rest}>
      {textContent}
    </StyledProductCol>
  );
};
Text.displayName = 'GeneralProductItem.Text';
